import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Helmet } from "../utils/Helmet";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/blog`)
      .then((r) => setPosts(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F4F4F1]">
      <Helmet
        title="Canadian RV, Motorcycle & Recreational Vehicle Transport Blog"
        description="Guides, pricing, and prep checklists for shipping RVs, motorcycles, ATVs, snowmobiles and boats across Canada — from Marine & Recreational Hauling, a direct carrier."
        canonical="https://marinerec-hauling.ca/blog"
      />
      <Navbar />
      <main>
        <section className="bg-[#122A1E] text-[#F4F4F1] border-b-2 border-[#122A1E]">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
            <div className="font-mono-accent text-[11px] uppercase text-[#FF5A00] mb-3">
              ◆ Blog · Canadian Hauling Insights
            </div>
            <h1 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl">
              Field Notes
              <br />
              <span className="text-[#FF5A00]">From the Road.</span>
            </h1>
            <p className="mt-6 max-w-xl text-[#F4F4F1]/80 text-lg">
              Pricing guides, prep checklists, and direct-carrier tips for
              shipping RVs, motorcycles, ATVs, snowmobiles and boats across
              Canada.
            </p>
          </div>
        </section>

        <section className="bg-[#F4F4F1] border-b-2 border-[#122A1E]">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
            {loading ? (
              <div className="text-[#4A5550] font-mono-accent text-sm">
                Loading…
              </div>
            ) : posts.length === 0 ? (
              <div
                className="border-2 border-[#122A1E] bg-[#EAEAE5] p-10 text-center"
                data-testid="blog-empty"
              >
                <div className="font-display font-black uppercase text-2xl text-[#0A0E0C]">
                  Posts coming soon.
                </div>
                <p className="mt-3 text-[#4A5550]">
                  Articles are being prepared. In the meantime — request a
                  quote.
                </p>
              </div>
            ) : (
              <div className="grid md:grid-cols-2 gap-5">
                {posts.map((p) => (
                  <Link
                    key={p.id}
                    to={`/blog/${p.slug}`}
                    className="group border-2 border-[#122A1E] bg-[#EAEAE5] hover-lift overflow-hidden flex flex-col"
                    data-testid={`blog-card-${p.slug}`}
                  >
                    {p.cover_image && (
                      <div className="h-56 overflow-hidden border-b-2 border-[#122A1E]">
                        <img
                          src={p.cover_image}
                          alt={p.title}
                          loading="lazy"
                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                      </div>
                    )}
                    <div className="p-7 flex flex-col flex-1">
                      <div className="font-mono-accent text-[10px] uppercase text-[#FF5A00] mb-2">
                        ◆ {p.tag || "guide"} · {new Date(p.created_at).toLocaleDateString("en-CA")}
                      </div>
                      <h2 className="font-display font-black uppercase tracking-tight text-[#0A0E0C] text-2xl leading-tight">
                        {p.title}
                      </h2>
                      <p className="mt-3 text-[#4A5550] text-sm leading-relaxed flex-1">
                        {p.excerpt}
                      </p>
                      <div className="mt-5 font-mono-accent text-[10px] uppercase text-[#122A1E] group-hover:text-[#FF5A00]">
                        Read article →
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
